import { render, staticRenderFns } from "./HeadlineSection.vue?vue&type=template&id=57223a35&scoped=true&"
import script from "./HeadlineSection.vue?vue&type=script&lang=js&"
export * from "./HeadlineSection.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineSection.vue?vue&type=style&index=0&id=57223a35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57223a35",
  null
  
)

export default component.exports